import { useParams } from 'react-router-dom';
import { BatchReview } from './components/BatchReview';

/**
 * Route wrapper for the read-only Batch review view (Story 3.1). Reads the `:batchId` route param
 * and hands it to {@link BatchReview}.
 *
 * `key={batchId}` forces a fresh mount whenever the route param changes: React Router reuses the
 * same `BatchReview` instance across a `/harness/batches/A` → `/harness/batches/B` navigation
 * (same route, different param, no unmount), so without the key its local state — selection,
 * Communication Log page — would carry over from the previous Batch.
 */
export function BatchReviewPage() {
  const { batchId } = useParams<{ batchId: string }>();

  if (!batchId) {
    return null;
  }

  return <BatchReview key={batchId} batchId={batchId} />;
}
